import { Notification, NotificationStateType } from 'src/shared/types/src/lib/notification.types';
import { Pagination } from 'src/shared/types/src/lib/app.types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: NotificationStateType = {
  isLoading: false,
  paginatedLoading: false,
  notificationList: [],
  unReadCount: 0,
  pagination: {
    currentPage: 1,
    from: 1,
    itemsPerPage: 0,
    lastPage: 1,
    to: 1,
    totalItems: 1,
  },
};

const notificationSlice = createSlice({
  name: 'notificationSlice',
  initialState,
  reducers: {
    setNotificationsLoader: (
      state,
      action: PayloadAction<{ isLoading: boolean }>
    ) => {
      state.isLoading = action.payload.isLoading;
    },
    setNotificationsPaginatedLoader: (
      state,
      action: PayloadAction<{ paginatedLoading: boolean }>
    ) => {
      state.paginatedLoading = action.payload.paginatedLoading;
    },
    appendNotifications: (
      state,
      action: PayloadAction<{ list: Notification[]; pagination: Pagination }>
    ) => {
      state.pagination = action.payload.pagination;
      state.notificationList.push(...action.payload.list);
    },
    resetNotificationState: (state, action) => {
      return {
        ...initialState,
        unReadCount: state.unReadCount,
      };
    },
    updateReadStatus: (state, action: PayloadAction<{ id: number }>) => {
      const notificationList = state.notificationList;
      const notificationIdx = state.notificationList.findIndex(
        (obj) => obj.id === action.payload.id
      );
      if (notificationIdx === -1) {
        return;
      }
      const updatedObj: Notification = {
        ...notificationList[notificationIdx],
        isRead: true,
      };
      state.notificationList = [
        ...notificationList.slice(0, notificationIdx),
        updatedObj,
        ...notificationList.slice(notificationIdx + 1),
      ];
    },
    setUnreadCount: (state, action: PayloadAction<{ unReadCount: number }>) => {
      state.unReadCount = action.payload.unReadCount;
    },
    markAllAsRead: (state) => {
      const newListData = state.notificationList.map((item) => { return { ...item, isRead: true } });
      state.notificationList = newListData;
      state.unReadCount = 0;
    },
    clearAll: (state) => {
      state.notificationList = [];
      state.unReadCount = 0;
    },
  },
});

export const NotificationActions = notificationSlice.actions;
export default notificationSlice.reducer;
